import React, { useRef } from 'react';
import classnames from 'classnames';

// Types
import { UserSuggestion } from 'Shared/types/UserSuggestion.type';

// Hooks
import useElementDimensions from 'Wpds/hooks/useElementDimensions';

// Components
import UserSuggestionsListItem from './UserSuggestionsListItem';

// Styles
import './UserSuggestionsList.scss';

type Props = {
  userSuggestions: UserSuggestion[];
};

const UserSuggestionsList = ({ userSuggestions }: Props) => {
  const ref = useRef();
  const { width: elementWidth } = useElementDimensions({ elementRef: ref });

  if (!userSuggestions) return null;

  const baseClassName = 'UserSuggestionsList';
  const classes = classnames(baseClassName, elementWidth < 600 ? `${baseClassName}--column` : '');
  const itemClasses = classnames(`${baseClassName}__item`, elementWidth < 600 ? `BaseUserSuggestionItem--column` : '');

  return (
    <div className={classes} ref={ref}>
      {userSuggestions.map(suggestion => (
        <UserSuggestionsListItem userSuggestion={suggestion} key={suggestion.slug} className={itemClasses} />
      ))}
    </div>
  );
};

export default UserSuggestionsList;
